module.exports = __webpack_public_path__ + "static/img/female-bg-fr.77fd8290.png";